import { topics } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h3 className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-2">Trending Topics</h3>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">热门话题</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">大家都在讨论什么？加入最热门的影视话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#hero"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-100 border-accent-300 text-accent-800 hover:bg-accent-200'
                  : 'bg-secondary-100 border-secondary-200 text-foreground-700 hover:bg-secondary-200'
              }`}
            >
              <span className="text-sm font-medium">{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-accent-600' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
              {topic.hot && (
                <span className="text-[10px] bg-accent-500 text-background-50 px-1.5 py-0.5 rounded-full leading-none">
                  热门
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}